export default __webpack_public_path__ + "static/media/nutrionist@3x.f9ec1d5d.png";